import { render, staticRenderFns } from "./ContolRegistration.vue?vue&type=template&id=15bf7b17&scoped=true&"
import script from "./ContolRegistration.vue?vue&type=script&lang=js&"
export * from "./ContolRegistration.vue?vue&type=script&lang=js&"
import style0 from "./ContolRegistration.vue?vue&type=style&index=0&id=15bf7b17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bf7b17",
  null
  
)

export default component.exports